import {
  SEND_A_CITYSPRINT_PARCEL,
  SEND_A_CITYSPRINT_PARCEL_COMPLETE_BOOKING,
  SEND_A_CITYSPRINT_PARCEL_REVIEW_BOOK,
} from '../../../constants/routes';

export const CITYSPRINT_STEPS = [
  { key: 'parcel', label: 'Parcel' },
  { key: 'details', label: 'Details' },
  { key: 'payment', label: 'Payment' },
];

export const CITYSPRINT_STEP_ROUTES = {
  parcel: SEND_A_CITYSPRINT_PARCEL,
  details: SEND_A_CITYSPRINT_PARCEL_COMPLETE_BOOKING,
  payment: SEND_A_CITYSPRINT_PARCEL_REVIEW_BOOK,
};

export const HOURS = Array.from({ length: 24 }, (_, i) =>
  String(i).padStart(2, '0')
);

export const MINUTES = Array.from({ length: 60 }, (_, i) =>
  String(i).padStart(2, '0')
);

export const REVIEW_BOOKING_DATETIME_FORMAT = 'Do MMMM YYYY HH:mm A';

export const EMPTY_DELIVERY = {
  addressId: '',
  postcode: '',
  organisation: '',
  street: '',
  locality: '',
  town: '',
  county: '',
  deliveryInstructions: '',
};

export const EMPTY_COLLECTION = {
  addressId: '',
  postcode: '',
  organisation: '',
  street: '',
  locality: '',
  town: '',
  county: '',
  collectionInstructions: '',
};

export const CITYSPRINT_INSTRUCTIONS_MAX_LENGTH = 100;

export const BOOKING_TIMING_SECTION_REENABLE_MS = 400;

export const ADDRESS_EDIT_RESET_DEBOUNCE_MS = 350;

export const QUOTE_SESSION_LOCK_ERROR =
  'Could not lock your quote. Please try again.';

export const CITYSPRINT_BACK_TO_PARCEL_CONFIRM = {
  TITLE: 'Lose your quote?',
  BODY: "Going back will clear your selected service. You'll need to fetch a new quote to continue.",
  CONFIRM_BUTTON: 'Go back',
};

export const CITYSPRINT_DETAILS_SECTIONS = {
  RECEIVER_DETAILS: 'Receiver Details',
  YOUR_DETAILS: 'Your Details',
};

export const CITYSPRINT_DETAILS_LABELS = {
  RECEIVER_FULL_NAME: 'Receiver full name',
  RECEIVER_EMAIL: 'Receiver email address',
  RECEIVER_PHONE: 'Receiver phone number',
  DELIVERY_INSTRUCTIONS: 'Delivery Instructions',
  YOUR_FULL_NAME: 'Your full name',
  YOUR_EMAIL: 'Your email address',
  YOUR_PHONE: 'Your phone number',
  COLLECTION_INSTRUCTIONS: 'Collection Instructions',
};

export const CITYSPRINT_INNER_PANEL_DARK_BG = '#2C2C2C';

export const CITYSPRINT_REVIEW = {
  TITLE: 'Review your booking',
  COLLECTION_BY_DATETIME: 'Collection by date & time',
  DELIVERY_BY_DATETIME: 'Delivery by date & time',
};

export const CITYSPRINT_CONFIRMATION = {
  CARD_TITLE: 'Your Same Day booking',
  BOOKING_REFERENCE: 'Booking reference',
  VEHICLE: 'Vehicle',
  SERVICE: 'Service',
  COLLECTION_WINDOW: 'Collection window',
  DELIVERY_WINDOW: 'Delivery window',
  WHAT_NEXT: 'What happens next',
  STEP_COURIER:
    'A CitySprint courier will collect your parcel in the collection window you chose.',
  STEP_TRACK:
    'Use the tracking link to follow progress and see updates on the day.',
  STEP_HELP:
    'Keep your booking reference handy if you need to contact CitySprint or DPD.',
  TRACK_PARCEL: 'TRACK YOUR PARCEL',
  DOWNLOAD_INVOICE: 'DOWNLOAD INVOICE',
  SEND_ANOTHER_PARCEL: 'SEND ANOTHER PARCEL',
  ORDER_NOT_FOUND: 'Order not found.',
  INVOICE_DOWNLOAD_FAILED:
    'We could not download your invoice. Please try again or contact support.',
  BOOKING_CREATED_SUCCESS: 'Booking have been successfully created',
  NO_STATE_HINT:
    'We could not load your booking details. Keep your booking reference below if you need help from CitySprint or DPD.',
};
